<template>
  <member-list
    gender="male"
    title-key="memberList.maleTitle"
  />
</template>

<script>
import MemberList from "../../components/MemberList.vue";

export default {
  name: "Male",
  components: {
    MemberList
  },
  created() {
    this.$parent.footer("male", true);
  },
  mounted() {
    if (localStorage.getItem("token") === null) {
      this.$router.push("/login");
    }
  }
};
</script>
